import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import { SeparatorAbsolute } from 'src/theme/styled'
import styled, { css } from 'styled-components'

import ActionButton from '../ActionButton'
import DownloadButton from '../DownloadButton'
import RichText from '../RichText'

type ContainerProps = {
  $compact?: boolean
  $mediaFirstOnMobile?: boolean
  $mediaFirstOnDesktop?: boolean
}

export const Container = styled(motion.section)<ContainerProps>`
  --edito-margin-inline__content: ${({ $mediaFirstOnDesktop }) =>
    $mediaFirstOnDesktop === true ? 'auto 0' : '0 auto'};
  position: relative;
  display: flex;
  flex-flow: ${({ $mediaFirstOnMobile }) =>
    $mediaFirstOnMobile === true ? 'column' : 'column-reverse'};
  align-items: stretch;
  gap: ${pxToRem(40)};
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  padding-block-start: ${pxToRem(24)};
  &:not(:first-child) {
    margin-block-start: ${({ $compact }) =>
      $compact === true
        ? 'var(--g_spacing__blocks--compact)'
        : 'var(--g_spacing__blocks)'};
  }
  @media ${mq(sizes.desktop)} {
    flex-flow: ${({ $mediaFirstOnDesktop }) =>
      $mediaFirstOnDesktop === true ? 'row' : 'row-reverse'};
    align-items: flex-start;
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Separator = styled(SeparatorAbsolute)<{ $visible?: boolean }>`
  @media ${mq(sizes.desktop)} {
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};
  }
`
export const Content = styled(motion.div)<{ $noMedia?: boolean }>`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(32)};
    ${({ $noMedia }) =>
      $noMedia === false
        ? css`
            max-width: 56ch;
            margin-inline: var(--edito-margin-inline__content);
          `
        : css`
            max-width: 50%;
            margin-inline-end: auto;
          `}
  }
`
export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.m375_h2}
  line-height: 1.25;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
    line-height: 1.25;
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_editoBody}
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(8)};
  // content
  & a {
    text-decoration: underline;
    color: inherit;
  }
  & a:hover {
    text-decoration: none;
  }
  & b,
  & strong {
    font-weight: 500;
  }
  & ul {
    display: flex;
    flex-flow: column;
    gap: ${pxToRem(16)};
    list-style: outside square;
    padding-inline-start: ${pxToRem(16)};
  }
  & ul > li {
    position: relative;
    padding-inline-start: ${pxToRem(16)};
  }
  & ol {
    list-style-position: outside;
    padding-inline-start: ${pxToRem(16)};
  }
  & ol > li {
    padding-inline-start: ${pxToRem(16)};
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_editoBody}
    gap: ${pxToRem(16)};
  }
`
export const Media = styled(motion.div)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(40)};
  @media ${mq(sizes.desktop)} {
    flex: 0 0 auto;
    width: 50%;
  }
`
export const Buttons = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    flex-flow: row;
  }
`
export const _ActionButton = styled(ActionButton)``
export const _DownloadButton = styled(DownloadButton)``
